<template>
    <div class="search-contents-wrap _saved">

        <button type="button" class="mobile-back-btn" v-on:click="mobileSearchBack">
            <div class="md_icon-btn _small">
                <div class="inner"><SvgIconBack /></div>
            </div>
            <p>BACK</p>
        </button>

        <div class="scroll-inner">
            <div class="item-wrap search-contents-inner">

                <div class="card_saved-criteria" id="sortableItem" v-bind:class="{_editActive:editActive}">

                    <div class="card_saved-criteria-title">
                        <h3>保存した検索条件一覧</h3>
                        <div class="edit-icon-wrap" v-bind:class="{_editActive:editActive}">
                            <!--EditIcon-->
                            <div class="md_icon-btn _white _edit" v-on:click="editActive=!editActive">
                                <div class="inner"><SvgIconEdit /></div>
                            </div>
                            <!--ReturnIcon-->
                            <div class="md_icon-btn _white _return" v-on:click="editAllClear">
                                <div class="inner"><SvgIconReturn /></div>
                            </div>
                        </div>
                    </div>

                    <SavedCriteriaCards />
                </div><!-- /.card_saved-criteria -->

            </div>
        </div>
    </div><!--/.search-contents-wrap._category-->
</template>


<script>
    //SvgIcon
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import SvgIconEdit from '@/components/EndUser/svg/SvgIconEdit'
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'
    import SvgIconReturn from '@/components/EndUser/svg/SvgIconReturn'

    //CardParts
    import SavedCriteriaCards from '@/components/EndUser/MenuSearchSavedCriteriaCards'

    export default {
        data() {
            return {
                editActive: false,
            }
        },
        components: {
            //SvgIcon
            SvgIconBack,
            SvgIconDelete,
            SvgIconEdit,
            SvgIconReturn,
            //CardParts
            SavedCriteriaCards,
        },
        methods: {
            editAllClear: function (e) {
                e.preventDefault();
                this.editActive = false;
                this.deleteActive = false;
            },

            ////////////////////////////////////
            //検索メニューMobile表示Backボタン
            ////////////////////////////////////
            mobileSearchBack: function () {
                this.tabSelectorActive = '';
                for (const element of document.getElementsByName('search-select')) {
                    element.checked = false;
                }
            },

        }
    }
</script>
